// src/components/legal-disclaimer/legal-disclaimer.tsx
function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties(source, excluded) {
  if (source == null) return {};
  var target = _object_without_properties_loose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _tagged_template_literal(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
function _type_of(obj) {
  "@swc/helpers - typeof";

  return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _templateObject() {
  var data = _tagged_template_literal(["\n  fragment EGDSIconFragment on Icon {\n    description\n    id\n    size\n    spotLight\n    title\n    theme\n    token\n    withBackground\n  }\n"]);
  _templateObject = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject1() {
  var data = _tagged_template_literal(["\n  fragment EGDSGraphicTextFragment on EGDSGraphicText {\n    text\n    graphic {\n      ...EGDSIconFragment\n    }\n  }\n\n  ", "\n"]);
  _templateObject1 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject2() {
  var data = _tagged_template_literal(["\n  fragment EGDSHeadingFragment on EGDSHeading {\n    accessibility\n    text\n  }\n"]);
  _templateObject2 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject3() {
  var data = _tagged_template_literal(["\n  fragment EGDSStylizedTextFragment on EGDSStylizedText {\n    accessibility\n    decorative\n    size\n    text\n    theme\n    weight\n  }\n"]);
  _templateObject3 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject4() {
  var data = _tagged_template_literal(["\n  fragment EGDSPlainTextFragment on EGDSPlainText {\n    text\n    accessibility\n  }\n"]);
  _templateObject4 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject5() {
  var data = _tagged_template_literal(["\n  fragment EGDSSpannableTextContentFragment on EGDSText {\n    ...EGDSHeadingFragment\n    ...EGDSStylizedTextFragment\n    ...EGDSPlainTextFragment\n    ...EGDSGraphicTextFragment\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject5 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject6() {
  var data = _tagged_template_literal(["\n  fragment EGDSSpannableTextFragment on EGDSSpannableText {\n    text\n    inlineContent {\n      ...EGDSSpannableTextContentFragment\n    }\n  }\n\n  ", "\n"]);
  _templateObject6 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject7() {
  var data = _tagged_template_literal(["\n  fragment LegalDisclaimerContentFragment on DisclaimerContent {\n    content {\n      ...EGDSSpannableTextFragment\n    }\n  }\n  ", "\n"]);
  _templateObject7 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject8() {
  var data = _tagged_template_literal(["\n  query LegalDisclaimerQuery($productIdentifier: ProductIdentifierInput!, $context: ContextInput!) {\n    legalDisclaimer(productIdentifier: $productIdentifier, context: $context) {\n      ...LegalDisclaimerContentFragment\n    }\n  }\n  ", "\n"]);
  _templateObject8 = function _templateObject() {
    return data;
  };
  return data;
}
import React17 from "react";
import { gql as gql9, useQuery } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
// src/components/legal-disclaimer/__private/__fragments/legal-disclaimer-content.tsx
import React16 from "react";
import { gql as gql8 } from "@apollo/client";
import { EGDSSpacing } from "@egds/react-core/spacing";
// ../internal/src/components/egds-text/egds-spannable-text.tsx
import React15 from "react";
import { gql as gql7 } from "@apollo/client";
import { UitkText as UitkText3 } from "uitk-react-text";
// ../internal/src/components/egds-text/egds-spannable-text-content.tsx
import React14 from "react";
import { gql as gql6 } from "@apollo/client";
// ../internal/src/components/egds-graphic-text/egds-graphic-text.tsx
import React10 from "react";
import { gql as gql2 } from "@apollo/client";
import { UitkText } from "uitk-react-text";
// ../internal/src/components/egds-icon/egds-icon.tsx
import React9 from "react";
import { gql } from "@apollo/client";
// ../../../../node_modules/.pnpm/tslib@2.3.1/node_modules/tslib/tslib.es6.js
var __assign = function __assign1() {
  __assign = Object.assign || function __assign2(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
// ../../../../node_modules/.pnpm/@shared-ui+brand-context@0.0.8_react@17.0.2/node_modules/@shared-ui/brand-context/dist/esmodule/brand-context.js
import * as React from "react";
var DEFAULTS = {
  getIcon: function getIcon(name) {
    return null;
  },
  getIconPath: function getIconPath(name) {
    return null;
  },
  getIconsHref: function getIconsHref(name) {
    return null;
  }
};
var Context = React.createContext(DEFAULTS);
var BrandProvider = function BrandProvider(props) {
  return React.createElement(Context.Provider, {
    value: props.config || DEFAULTS
  }, props.children);
};
BrandProvider.displayName = "BrandProvider";
var useBrand = function useBrand() {
  return React.useContext(Context);
};
// ../../../../node_modules/.pnpm/@shared-ui+experiment-context@2.0.2_react@17.0.2/node_modules/@shared-ui/experiment-context/dist/esmodule/experiment-context.js
import * as React2 from "react";
var defaults = {
  getExposure: function getExposure(name) {
    return null;
  },
  logExperiment: function logExperiment(exposure) {
    return void 0;
  }
};
var ExperimentContext = React2.createContext(defaults);
// ../../../../node_modules/.pnpm/@shared-ui+experiment-context@2.0.2_react@17.0.2/node_modules/@shared-ui/experiment-context/dist/esmodule/components/experiment-control.js
import * as React3 from "react";
// ../../../../node_modules/.pnpm/@shared-ui+experiment-context@2.0.2_react@17.0.2/node_modules/@shared-ui/experiment-context/dist/esmodule/components/experiment-variant.js
import * as React4 from "react";
// ../../../../node_modules/.pnpm/@shared-ui+experiment-context@2.0.2_react@17.0.2/node_modules/@shared-ui/experiment-context/dist/esmodule/components/experiment.js
import * as React5 from "react";
import { useContext as useContext2, useEffect } from "react";
var useExperiment = function useExperiment(name, shouldLogExperiment) {
  var _a;
  var _b = useContext2(ExperimentContext),
    getExposure = _b.getExposure,
    logExperiment = _b.logExperiment;
  var exposure = (_a = getExposure(name)) !== null && _a !== void 0 ? _a : {
    name: name,
    bucket: 0
  };
  useEffect(function () {
    if (exposure && shouldLogExperiment) {
      try {
        logExperiment(exposure);
      } catch (e) {}
    }
  }, [logExperiment]);
  return {
    exposure: exposure,
    logExperiment: logExperiment
  };
};
// ../../../../node_modules/.pnpm/@shared-ui+experiment-context@2.0.2_react@17.0.2/node_modules/@shared-ui/experiment-context/dist/esmodule/components/mock-experiment-provider.js
import * as React6 from "react";
// ../../../../node_modules/.pnpm/uitk-react-icons@10.10.4_@egds+tokens-web@5.4.26_@shared-ui+brand-context@0.0.8_react@17.0.2__6gtxuldvo6difm37rofsu4cnha/node_modules/uitk-react-icons/dist/uitk-icon.esm.js
import * as React8 from "react";
// ../../../../node_modules/.pnpm/uitk-react-utils@3.2.2_react@17.0.2_tslib@2.3.1/node_modules/uitk-react-utils/dist/classnames.esm.js
function classNames() {
  var args = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    args[_i] = arguments[_i];
  }
  var classes = [];
  var _this = typeof window !== "undefined" && this === window ? void 0 : this;
  for (var _a = 0, args_1 = args; _a < args_1.length; _a++) {
    var arg = args_1[_a];
    if (!arg) {
      continue;
    }
    var argType = typeof arg === "undefined" ? "undefined" : _type_of(arg);
    if (argType === "string") {
      var argStrToArray = arg.split(" ");
      if (_this && argStrToArray.length > 1) {
        classes.push(classNames.apply(_this, argStrToArray));
      } else {
        classes.push((_this === null || _this === void 0 ? void 0 : _this[arg]) || arg);
      }
    } else if (Array.isArray(arg)) {
      [].concat.apply([], arg).filter(Boolean).length && classes.push(classNames.apply(_this !== null && _this !== void 0 ? _this : null, arg));
    } else if (argType === "object") {
      if (arg.toString === Object.prototype.toString) {
        for (var key in arg) {
          if ({}.hasOwnProperty.call(arg, key) && arg[key]) {
            classes.push((_this === null || _this === void 0 ? void 0 : _this[key]) || key);
          }
        }
      } else {
        classes.push(arg.toString());
      }
    }
  }
  return classes.join(" ");
}
// ../../../../node_modules/.pnpm/uitk-react-utils@3.2.2_react@17.0.2_tslib@2.3.1/node_modules/uitk-react-utils/dist/uitk-context-provider.esm.js
import * as React7 from "react";
var Context2 = React7.createContext({
  context: null
});
var useUitkContext = function useUitkContext() {
  return React7.useContext(Context2);
};
var UitkContextProvider = function UitkContextProvider(_a) {
  var children = _a.children,
    config = _a.config;
  return React7.createElement(Context2.Provider, {
    value: config
  }, children);
};
UitkContextProvider.displayName = "UitkContextProvider";
// ../../../../node_modules/.pnpm/uitk-react-utils@3.2.2_react@17.0.2_tslib@2.3.1/node_modules/uitk-react-utils/dist/validate-prop-types.esm.js
var validatePropType = function validatePropType(prop, type) {
  if (prop && type) {
    var PropAvailability = Object.keys(type).map(function (key) {
      return type[key];
    }).indexOf(prop) > -1;
    if (!PropAvailability) {
      console.error(PropAvailability, "Expected values: ".concat(Object.keys(type).join(", ")));
    }
    return PropAvailability;
  }
};
// ../../../../node_modules/.pnpm/uitk-react-utils@3.2.2_react@17.0.2_tslib@2.3.1/node_modules/uitk-react-utils/dist/index.esm.js
if (typeof document !== "undefined") {
  addBodyClass_1 = function () {
    if (!document.body.classList.contains("uitk-no-outline")) {
      document.body.classList.add("uitk-no-outline");
      document.body.removeEventListener("mousedown", addBodyClass_1);
      document.body.addEventListener("keydown", removeBodyClass_1);
    }
  };
  removeBodyClass_1 = function () {
    if (document.body.classList.contains("uitk-no-outline")) {
      document.body.classList.remove("uitk-no-outline");
      document.body.removeEventListener("keydown", removeBodyClass_1);
      document.body.addEventListener("mousedown", addBodyClass_1);
    }
  };
  addBodyClass_1();
}
var addBodyClass_1;
var removeBodyClass_1;
// ../../../../node_modules/.pnpm/uitk-react-icons@10.10.4_@egds+tokens-web@5.4.26_@shared-ui+brand-context@0.0.8_react@17.0.2__6gtxuldvo6difm37rofsu4cnha/node_modules/uitk-react-icons/dist/types.esm.js
var UitkIconThemeMap = [["positive", "uitk-icon-positive-theme"], ["negative", "uitk-icon-negative-theme"], ["primary", "uitk-icon-primary-theme"], ["secondary", "uitk-icon-secondary-theme"], ["inverse", "uitk-icon-inverse-theme"], ["emphasis", "uitk-icon-emphasis-theme"], ["default", "uitk-icon-default-theme"]];
var UitkIconThemes = new Map(UitkIconThemeMap);
// ../../../../node_modules/.pnpm/uitk-react-icons@10.10.4_@egds+tokens-web@5.4.26_@shared-ui+brand-context@0.0.8_react@17.0.2__6gtxuldvo6difm37rofsu4cnha/node_modules/uitk-react-icons/dist/uitk-icons.css
var uitk_icons_default = {};
// ../../../../node_modules/.pnpm/uitk-react-icons@10.10.4_@egds+tokens-web@5.4.26_@shared-ui+brand-context@0.0.8_react@17.0.2__6gtxuldvo6difm37rofsu4cnha/node_modules/uitk-react-icons/dist/uitk-icon.esm.js
var getClassNameList = classNames.bind(uitk_icons_default);
var UitkIconSize;
(function (UitkIconSize2) {
  UitkIconSize2["EXTRA_SMALL"] = "xsmall";
  UitkIconSize2["SMALL"] = "small";
  UitkIconSize2["MEDIUM"] = "medium";
  UitkIconSize2["LARGE"] = "large";
  UitkIconSize2["XLARGE"] = "xlarge";
})(UitkIconSize || (UitkIconSize = {}));
var UitkIcon = function UitkIcon(props) {
  var _a;
  var baseCssClass = "uitk-icon";
  var throwNameError = function throwNameError(nameError) {
    typeof window !== "undefined" && console.error("Invalid icon name prop: ".concat(nameError));
  };
  var className = props.className,
    description = props.description,
    id = props.id,
    name = props.name,
    size = props.size,
    theme = props.theme,
    title = props.title,
    shadow = props.shadow,
    spotlight = props.spotlight;
  var contextData = useUitkContext().data;
  var contextClassNames = (contextData !== null && contextData !== void 0 ? contextData : {}).contextClassNames;
  if (!name) {
    throwNameError(name);
  }
  if ((title || description) && !id && typeof window !== "undefined") {
    console.error("Icon ".concat(name, " requires 'id' if 'title' or 'description' are provided"));
  }
  var dropShadowValues = {
    dx: 0,
    dy: 0,
    stdDeviation: 1
  };
  var uid = Math.random().toString(36).substring(7);
  var filterId = "shadow-filter".concat(id ? "-".concat(id) : "-".concat(uid));
  var domRef = function domRef(b) {};
  var isDirectional = name && /_(?:back|forward|left|right|before|next|half)$/.test(name);
  var spotLightIsObject = typeof spotlight === "object";
  var newSpotlight = false;
  if (spotLightIsObject) {
    newSpotlight = spotlight;
  } else if (spotlight) {
    newSpotlight = {
      theme: spotlight,
      background: true
    };
  }
  var wrapperClassNames = getClassNameList(baseCssClass, className, contextClassNames === null || contextClassNames === void 0 ? void 0 : contextClassNames.UitkIcon, (_a = {}, _a["".concat(baseCssClass, "-directional")] = isDirectional, _a["".concat(baseCssClass, "-").concat(size)] = validatePropType(size, UitkIconSize) && !spotlight && size !== UitkIconSize.MEDIUM, _a["".concat(baseCssClass, "-spotlight-icon")] = newSpotlight, _a), theme && !spotlight && UitkIconThemes.get(theme));
  var spotlightIconContainerClassNames = getClassNameList(newSpotlight && ["".concat(baseCssClass, "-spotlight"), "".concat(baseCssClass, "-spotlight-").concat(newSpotlight.theme), newSpotlight.background && "".concat(baseCssClass, "-spotlight-has-background")]);
  var isSVGFEDropShadowElement = typeof SVGFEDropShadowElement === "function";
  var style = shadow && isSVGFEDropShadowElement ? {
    filter: "url(#".concat(filterId, ")")
  } : void 0;
  var getIconPath = useBrand().getIconPath;
  var pathToRender = function pathToRender(svgName) {
    var iconToRender = (svgName === null || svgName === void 0 ? void 0 : svgName.indexOf("icon__")) === 0 ? svgName.replace("icon__", "") : svgName;
    var iconPathString = getIconPath === null || getIconPath === void 0 ? void 0 : getIconPath(iconToRender);
    iconPathString || throwNameError(svgName);
    return iconPathString || "";
  };
  var svgNodes = [title && '<title id="'.concat(id, '-title">').concat(title, "</title>"), description && '<desc id="'.concat(id, '-description">').concat(description, "</desc>"), shadow && '<defs>\n      <filter id="'.concat(filterId, '">\n        <feDropShadow dx="').concat(dropShadowValues.dx, '" dy="').concat(dropShadowValues.dy, '" stdDeviation="').concat(dropShadowValues.stdDeviation, '"/>\n      </filter>\n    </defs>')].filter(Boolean).join("");
  var a11yProps = {
    "aria-describedby": description ? "".concat(id, "-description") : void 0,
    "aria-hidden": title || description ? void 0 : true,
    "aria-label": title || void 0,
    role: title || description ? "img" : void 0
  };
  var iconProps = {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  };
  var svgProps = __assign(__assign({
    ref: domRef,
    className: wrapperClassNames,
    style: style
  }, a11yProps), iconProps);
  var innerNodes = function innerNodes(html) {
    if (html.length > 0) {
      return {
        dangerouslySetInnerHTML: {
          __html: html
        }
      };
    }
    return {};
  };
  var exposure = useExperiment("Bernie_SVG_delivery", true).exposure;
  var innerNodesMarkup = (exposure === null || exposure === void 0 ? void 0 : exposure.bucket) === 1 || (exposure === null || exposure === void 0 ? void 0 : exposure.bucket) === 2 ? "".concat(svgNodes, '<use href="#').concat(name, '" />') : "".concat(svgNodes).concat(pathToRender(name));
  var iconMarkup = React8.createElement("svg", __assign({}, svgProps, innerNodes(innerNodesMarkup)));
  return spotlight ? React8.createElement("div", {
    className: spotlightIconContainerClassNames
  }, iconMarkup) : iconMarkup;
};
UitkIcon.defaultProps = {
  size: UitkIconSize.MEDIUM
};
UitkIcon.displayName = "UitkIcon";
var _obj;
// ../internal/src/components/egds-icon/__private/spotlight-mapper.ts
var spotlightMapper = (_obj = {}, _define_property(_obj, "INFO" /* INFO */, "info"), _define_property(_obj, "POSITIVE" /* POSITIVE */, "positive"), _define_property(_obj, "WARNING" /* WARNING */, "warning"), _define_property(_obj, "STANDARD" /* STANDARD */, "standard"), _obj);
// ../internal/src/components/egds-icon/egds-icon.tsx
var fragment = gql(_templateObject());
var EGDSIcon = function (param) {
  var className = param.className,
    defaultIconSize = param.defaultIconSize,
    data = param.data,
    spotlight = param.spotlight;
  var id = data.id,
    token = data.token;
  if (!id || !token) {
    return null;
  }
  var description = data.description,
    withBackground = data.withBackground,
    size = data.size,
    spotLightData = data.spotLight,
    title = data.title,
    theme = data.theme;
  return /* @__PURE__ */React9.createElement(UitkIcon, {
    className: className,
    description: description,
    id: id,
    name: token,
    shadow: withBackground !== null && withBackground !== void 0 ? withBackground : void 0,
    size: size ? UitkIconSize[size] : defaultIconSize,
    spotlight: spotLightData ? spotlightMapper[spotLightData] : spotlight,
    title: title !== null && title !== void 0 ? title : void 0,
    theme: theme !== null && theme !== void 0 ? theme : void 0
  });
};
EGDSIcon.fragment = fragment;
EGDSIcon.displayName = "UitkIcon";
// ../internal/src/components/egds-graphic-text/egds-graphic-text.tsx
var fragment2 = gql2(_templateObject1(), EGDSIcon.fragment);
var EGDSGraphicText = function (param) {
  var data = param.data,
    textProps = param.textProps,
    _param_size = param.size,
    size = _param_size === void 0 ? 200 : _param_size;
  if (!(data === null || data === void 0 ? void 0 : data.text)) {
    return null;
  }
  var text = data.text,
    graphic = data.graphic;
  var graphicElement = function () {
    if (graphic.__typename === "Icon") {
      return /* @__PURE__ */React10.createElement(EGDSIcon, {
        data: graphic
      });
    }
  };
  return /* @__PURE__ */React10.createElement(UitkText, _object_spread({
    size: size
  }, textProps), graphicElement(), text);
};
EGDSGraphicText.fragment = fragment2;
EGDSGraphicText.displayName = "EGDSGraphicText";
// ../internal/src/components/egds-heading/egds-heading.tsx
import React11 from "react";
import { gql as gql3 } from "@apollo/client";
import { EGDSHeading as EGDSReactCoreHeading } from "@egds/react-core/text";
var fragment3 = gql3(_templateObject2());
var EGDSHeading = function (props) {
  var data = props.data,
    className = props.className,
    size = props.size,
    align = props.align,
    tag = props.tag;
  var accessibility = data.accessibility,
    text = data.text;
  if (!text) {
    return null;
  }
  return /* @__PURE__ */React11.createElement(EGDSReactCoreHeading, {
    className: className,
    size: size,
    align: align,
    tag: tag,
    "aria-label": accessibility !== null && accessibility !== void 0 ? accessibility : void 0
  }, text);
};
EGDSHeading.fragment = fragment3;
EGDSHeading.displayName = "EGDSHeading";
// ../internal/src/components/egds-stylized-text/egds-stylized-text.tsx
import React12 from "react";
import { gql as gql4 } from "@apollo/client";
import { EGDSText } from "@egds/react-core/text";
var _obj1;
// ../internal/src/components/egds-stylized-text/__private/mapper.ts
var UitkThemeMap = Object.freeze((_obj1 = {}, _define_property(_obj1, "NEGATIVE" /* NEGATIVE */, "negative"), _define_property(_obj1, "POSITIVE" /* POSITIVE */, "positive"), _define_property(_obj1, "PRIMARY" /* PRIMARY */, "emphasis"), _define_property(_obj1, "SECONDARY" /* SECONDARY */, "default"), _define_property(_obj1, "LOYALTY" /* LOYALTY */, "loyalty"), _define_property(_obj1, "INVERSE" /* INVERSE */, "inverse"), _define_property(_obj1, "default", "default"), _obj1));
var _obj2;
var UitkWeightMap = Object.freeze((_obj2 = {}, _define_property(_obj2, "BOLD" /* BOLD */, "bold"), _define_property(_obj2, "MEDIUM" /* MEDIUM */, "medium"), _define_property(_obj2, "REGULAR" /* REGULAR */, "regular"), _obj2));
var UitkSizeMap = Object.freeze({
  "100": 100,
  "200": 200,
  "300": 300,
  "400": 400,
  "500": 500,
  "600": 600,
  "700": 700,
  "800": 800,
  "900": 900
});
var DecorativeMap = Object.freeze({
  HIGHLIGHT: "mark",
  LINE_THROUGH: "s",
  SUBSCRIPT: "sub",
  SUPERSCRIPT: "sup",
  UNDERLINE: "u"
});
// ../internal/src/components/egds-stylized-text/egds-stylized-text.tsx
var fragment4 = gql4(_templateObject3());
var EGDSStylizedText = function (_param) {
  var data = _param.data,
    _param_theme = _param.theme,
    theme = _param_theme === void 0 ? "default" : _param_theme,
    _param_weight = _param.weight,
    weight = _param_weight === void 0 ? "regular" : _param_weight,
    _param_size = _param.size,
    size = _param_size === void 0 ? 300 : _param_size,
    props = _object_without_properties(_param, ["data", "theme", "weight", "size"]);
  if (!(data === null || data === void 0 ? void 0 : data.text)) {
    return null;
  }
  var text = data.text,
    decorative = data.decorative,
    accessibility = data.accessibility;
  var textProps = _object_spread({
    theme: (data === null || data === void 0 ? void 0 : data.theme) ? UitkThemeMap[data.theme] : theme,
    weight: (data === null || data === void 0 ? void 0 : data.weight) ? UitkWeightMap[data.weight] : weight,
    size: (data === null || data === void 0 ? void 0 : data.size) ? UitkSizeMap[data.size] : size
  }, props);
  var Decorative = decorative && DecorativeMap[decorative];
  var content = Decorative ? /* @__PURE__ */React12.createElement(Decorative, null, text) : text;
  return /* @__PURE__ */React12.createElement(React12.Fragment, null, /* @__PURE__ */React12.createElement(EGDSText, _object_spread({
    "aria-hidden": Boolean(accessibility)
  }, textProps), content), accessibility && /* @__PURE__ */React12.createElement("span", {
    className: "is-visually-hidden"
  }, accessibility));
};
EGDSStylizedText.fragment = fragment4;
EGDSStylizedText.displayName = "EGDSStylizedText";
// ../internal/src/components/egds-text/egds-plain-text.tsx
import React13 from "react";
import { gql as gql5 } from "@apollo/client";
import { UitkText as UitkText2 } from "uitk-react-text";
var fragment5 = gql5(_templateObject4());
var EGDSPlainText = function (param) {
  var className = param.className,
    inline = param.inline,
    size = param.size,
    align = param.align,
    data = param.data,
    spacing = param.spacing;
  if (!(data === null || data === void 0 ? void 0 : data.text)) {
    return null;
  }
  var text = data.text,
    accessibility = data.accessibility;
  return /* @__PURE__ */React13.createElement(UitkText2, {
    className: className,
    inline: inline,
    size: size,
    align: align,
    spacing: spacing
  }, text, accessibility && /* @__PURE__ */React13.createElement("span", {
    className: "is-visually-hidden"
  }, accessibility));
};
EGDSPlainText.fragment = fragment5;
EGDSPlainText.displayName = "EGDSPlainText";
// ../internal/src/components/egds-text/egds-spannable-text-content.tsx
var fragment6 = gql6(_templateObject5(), EGDSHeading.fragment, EGDSStylizedText.fragment, EGDSPlainText.fragment, EGDSGraphicText.fragment);
var EGDSSpannableTextContent = function (param) {
  var className = param.className,
    size = param.size,
    headingProps = param.headingProps,
    data = param.data,
    inline = param.inline;
  switch (data.__typename) {
    case "EGDSHeading":
      return /* @__PURE__ */React14.createElement(EGDSHeading, _object_spread({
        data: data
      }, headingProps));
    case "EGDSStylizedText":
      return /* @__PURE__ */React14.createElement(EGDSStylizedText, {
        className: className,
        data: data,
        size: size,
        inline: inline
      });
    case "EGDSPlainText":
      return /* @__PURE__ */React14.createElement(EGDSPlainText, {
        className: className,
        data: data,
        size: size,
        inline: inline
      });
    case "EGDSGraphicText":
      return /* @__PURE__ */React14.createElement(EGDSGraphicText, {
        data: data,
        size: size
      });
    default:
      return null;
  }
};
EGDSSpannableTextContent.fragment = fragment6;
EGDSSpannableTextContent.displayName = "EGDSSpannableTextContent";
// ../internal/src/components/egds-text/egds-spannable-text.tsx
var fragment7 = gql7(_templateObject6(), EGDSSpannableTextContent.fragment);
var EGDSSpannableText = function (props) {
  var _data_inlineContent;
  var align = props.align,
    data = props.data,
    styleProps = _object_without_properties(props, ["align", "data"]);
  if (data === null || data === void 0 ? void 0 : (_data_inlineContent = data.inlineContent) === null || _data_inlineContent === void 0 ? void 0 : _data_inlineContent.length) {
    return /* @__PURE__ */React15.createElement(React15.Fragment, null, data.inlineContent.map(function (item, index) {
      return /* @__PURE__ */React15.createElement(EGDSSpannableTextContent, _object_spread_props(_object_spread({
        data: item
      }, styleProps), {
        key: "spannable-item-".concat(index)
      }));
    }));
  }
  if (data === null || data === void 0 ? void 0 : data.text) {
    return /* @__PURE__ */React15.createElement(UitkText3, _object_spread_props(_object_spread({}, styleProps), {
      inline: true,
      align: align
    }), data.text);
  }
  return null;
};
EGDSSpannableText.fragment = fragment7;
EGDSSpannableText.displayName = "EGDSSpannableText";
// src/components/utils/style-config.ts
var spannableTextStyleOverride = _define_property({}, "CRUISE" /* CRUISE */, {
  size: 200,
  headingProps: {
    size: 8
  }
});
// src/components/legal-disclaimer/__private/__fragments/legal-disclaimer-content.tsx
var fragment8 = gql8(_templateObject7(), EGDSSpannableText.fragment);
var LegalDisclaimerContent = function (param) {
  var data = param.data,
    productLine = param.productLine;
  var content = data.content;
  var spannableTextStyleProps = productLine && spannableTextStyleOverride[productLine];
  return /* @__PURE__ */React16.createElement(React16.Fragment, null, content.map(function (item, index) {
    return /* @__PURE__ */React16.createElement(EGDSSpacing, {
      padding: {
        blockend: index < content.length - 1 ? "two" : void 0
      },
      key: "uitk-spacing-".concat(index)
    }, /* @__PURE__ */React16.createElement("div", null, /* @__PURE__ */React16.createElement(EGDSSpannableText, _object_spread_props(_object_spread({
      data: item
    }, spannableTextStyleProps), {
      key: "egds-spannable-text-".concat(index)
    }))));
  }));
};
LegalDisclaimerContent.fragment = fragment8;
LegalDisclaimerContent.displayName = "LegalDisclaimerContent";
// src/components/legal-disclaimer/legal-disclaimer.tsx
var __Query = gql9(_templateObject8(), LegalDisclaimerContent.fragment);
var LegalDisclaimer = function (props) {
  var inputs = props.inputs,
    skipSsr = props.skipSsr,
    batchKey = props.batchKey;
  var context = useBexApi().context;
  var variables = _object_spread_props(_object_spread({}, inputs), {
    context: context
  });
  var _useQuery = useQuery(__Query, {
      context: {
        batchKey: batchKey
      },
      variables: variables,
      ssr: !skipSsr
    }),
    data = _useQuery.data,
    error = _useQuery.error,
    loading = _useQuery.loading;
  if (loading || error || !data) {
    return null;
  }
  var productLine = inputs.productIdentifier.productLine;
  var legalDisclaimer = data.legalDisclaimer;
  return legalDisclaimer && /* @__PURE__ */React17.createElement(LegalDisclaimerContent, {
    data: legalDisclaimer,
    productLine: productLine
  });
};
LegalDisclaimer.displayName = "sharedui-LegalDisclaimer";
export { LegalDisclaimer }; /*! Bundled license information:
                            tslib/tslib.es6.js:
                            (*! *****************************************************************************
                            Copyright (c) Microsoft Corporation.
                            Permission to use, copy, modify, and/or distribute this software for any
                            purpose with or without fee is hereby granted.
                            THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
                            REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
                            AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
                            INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
                            LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
                            OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
                            PERFORMANCE OF THIS SOFTWARE.
                            ***************************************************************************** *)
                            */